export const GYM_RANKS = [
  { id: 'rookie', label: 'Principiante', description: 'Comenzando la aventura fitness.' },
  { id: 'novice', label: 'Novato', description: 'Sumando constancia y aprendiendo técnica.' },
  { id: 'recruit', label: 'Recluta', description: 'Parte esencial del equipo Sportivos.' },
  { id: 'athlete', label: 'Guerrero', description: 'Compromiso alto con el entrenamiento.' },
  { id: 'gym-royalty', label: 'Rey del Gimnasio', description: 'La energía que inspira a los demás.' },
  { id: 'gymrat', label: 'Gym Rat', description: 'Vive dentro del box, 100% disciplina.' },
];
